<div class="auth-content">
    <div class="header">
        <div class="top-hdr">
            <img ngSrc="assets/images/CGI_logo_color_rgb.svg" alt="CGI logo" height="90" width="135" priority>
            <div class="sub-title">
                Federal
            </div>
        </div>
        <h1>
            <div class="title">CGI Assist</div>
        </h1>
    </div>
    <button matButton="filled" (click)="onSignin()" class="btn-signin" type="button">Sign in</button>
  </div>

  <div class="spacer"></div>
  <div class="bottom-banner">

    <div class="notice">
        <div>
            <mat-icon class="material-symbols-outlined" fontIcon="priority_high" />
        </div>
        <p>
            CGI Assist is only available to CGI Federal Members using CGI Federal issued laptops when
            connected to the CGI Federal network.
        </p>
    </div>
</div>
